import {
  AuthVerifyOtpBodyType,
  AuthVerifyOtpResponseType
} from "@website/widget/login/services/auth-verify-otp/auth-verify-otp.types";
import { BASE_URL_PROFILE } from "@website/widget/login/services/urls";
import { Axios } from "@website/widget/login/utils";
import { AxiosResponse } from "axios";

export const AuthVerifyOtpUrl = `${BASE_URL_PROFILE}/auth/verify-otp`;

export const AuthVerifyOtpService = (
  body: AuthVerifyOtpBodyType
): Promise<AuthVerifyOtpResponseType> =>
  Axios.post(AuthVerifyOtpUrl, body).then(
    ({ data }: AxiosResponse<AuthVerifyOtpResponseType>) => data
  );
